import { render, staticRenderFns } from "./LoyaltyBonusTypeUpdateComponent.vue?vue&type=template&id=795c8e6a&scoped=true"
import script from "./LoyaltyBonusTypeUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyBonusTypeUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c8e6a",
  null
  
)

export default component.exports